import React, { Dispatch, FC, useEffect, useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useValue } from '../../../hooks/entityHooks';
import classes from './filter.module.scss';
import { ReactComponent as Test1 } from '../../../assets/images/test1.svg';

type FilterProps = {
  onChange: Dispatch<number>;
  id?: number;
  type: 'Window' | 'Page';
  update?: boolean;
  isToolbar?: boolean;
};

const Filter: FC<FilterProps> = ({ id, onChange, type, update, isToolbar }) => {
  const { entityList, getEntityList: getValues } = useValue();
  const [age, setAge] = useState<string>('');

  const handleChange = (event: any) => {
    setAge(event.target.value);
    onChange(event.target.value);
  };

  useEffect(() => {
    getValues().then(() => {});
  }, [update]);

  return (
    <div
      className={`${classes.wrapper} ${type === 'Window' && classes.window} ${
        (id || age) && classes.closed
      }`}
    >
      <FormControl
        variant="filled"
        className={!isToolbar ? classes.formControl : classes.formControlTwo}
      >
        <InputLabel
          id="demo-simple-select-filled-label"
          style={{
            marginLeft: !isToolbar ? -20 : 0,
            fontWeight: 550,
            fontSize: 14,
          }}
        >
          Все спасибо
        </InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={id || age}
          onChange={handleChange}
        >
          <MenuItem value={Infinity}>
            <ListItemText primary="Все спасибо" />
          </MenuItem>

          {entityList &&
            entityList.map((elem) => (
              <MenuItem value={elem.id}>
                <ListItemText primary={elem.name} />
                <ListItemIcon style={{ minWidth: 36 }}>
                  {elem.icon ? (
                    <img
                      src={`https://radar-app.tmk-group.com/${elem.icon}`}
                      alt={`${elem.name}`}
                    />
                  ) : (
                    <Test1 />
                  )}
                </ListItemIcon>
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default Filter;
